export interface PrefetchConfig {
  url: string;
  bundleNames: string[];
}

/**
 * fetchManifest
 *
 * Grabs an app manifest to determine locations of assets to prefetch.
 *
 * @param {PrefetchConfig} config A config specifying manifest location and assets to get.
 *
 * @returns {string[]}
 */
export async function fetchManifest(config: PrefetchConfig) {
  const response = await fetch(config.url, { cache: "no-cache" });
  const manifest: { [key: string]: string } = await response.json();

  return config.bundleNames.map((bundleName) => manifest[bundleName]).filter((asset) => Boolean(asset));
}

/**
 * prefetchAssets
 *
 * Appends a series of links to the <head> of the document.
 *
 * @param {string[]} bundles List of URLs to JavaScript assets.
 *
 * @returns {void}
 */
export function prefetchAssets(bundles: string[]) {
  bundles.forEach((bundle: string) => {
    const head = document.querySelector("head");

    const link = document.createElement("link");
    link.rel = "prefetch";
    link.href = bundle;
    link.as = "script";

    head?.appendChild(link);
  });
}
